<div class="customizer-menu">
	@if (components !== null) {
	<div class="menu-list">
		@for (component of components; track $index) {
		@if (shouldShowComponent(component)) {
		<div class="text-center menu" (click)="setCurrentMainComponent(component);" [ngClass]="{ nohover: blocked, active: IsSelected(component.id), 'submenu-like': IsSelected(component.id) && ComponentIsPlaceholderForSubcomponents(component)}">
			@if (component.error) {
			<i [ngClass]="'menu-icon icon-error-' + component.icon.toLowerCase()"></i>
			}
			@else {
			<i [ngClass]="'menu-icon icon-' + component.icon.toLowerCase()"></i>
			}

			<div class="menu-title" [ngClass]="{'menu-error-text': component.error}">{{"CUSTOMIZER.COMPONENTS." + component.translateName + ".NAME" | translate}}</div>

			@if (shouldComponentShowVisited(component)) {
			<i class="fa-thin fa-check checkmark checkmark-style"></i>
			}
		</div>
		<div class="submenus" [ngClass]="{'submenu-active': currentMainComponent?.id === component.id, 'submenu-inactive': currentMainComponent?.id !== component.id}">
			@for (subComponent of component.subComponentsToShow; track $index; let last = $last) {
			<div [@submenuAnim]="getState(subComponent)" class="submenu" (click)="setCurrentSubComponent(subComponent)" [ngClass]="{nohover: blocked,submenuActive: currentSubComponent && subComponent.id === currentSubComponent.id,'has-shadow-bottom': last}">
				@if (component.error) {
				<i [ngClass]="'menu-icon icon-error-' + subComponent.icon.toLowerCase()"></i>
				}
				@else {
				<i [ngClass]="'menu-icon icon-' + subComponent.icon.toLowerCase()"></i>
				}

				<div class="menu-title" [ngClass]="{'menu-error-text': component.error}">{{"CUSTOMIZER.COMPONENTS." + subComponent.translateName + ".NAME" | translate}}</div>

				@if (subComponent.isVisited) {
				<i class="fa-thin fa-check checkmark checkmark-style"></i>
				}
			</div>
			}
		</div>
		}
		}
	</div>
	}
</div>